import { useState } from "react";

export const collectionsOf = (collections, category) =>
  (collections || []).filter((c) => c.category === category).sort((a, b) => a.name.localeCompare(b.name));

// Entries per collection (an entry can appear in several), plus the ones in none
export const groupByCollection = (entries, cols) => {
  const groups = cols.map((c) => ({ col: c, items: entries.filter((p) => p.collection_ids?.includes(c.id)) }));
  const ids = new Set(cols.map((c) => c.id));
  return { groups, rest: entries.filter((p) => !(p.collection_ids || []).some((id) => ids.has(id))) };
};

// Folded state per device
export const useFold = (key, initial = false) => {
  const k = `lorely.fold:${key}`;
  const [folded, setState] = useState(() => (localStorage.getItem(k) ?? String(initial)) === "true");
  const toggle = () => setState((f) => { localStorage.setItem(k, String(!f)); return !f; });
  return [folded, toggle];
};
